import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login.component';
import {ForgotPasswordComponent} from './forgot-password/forgot-password.component';
import {FirstTimeLoginComponent} from './first-time-login/first-time-login.component';
import {NotFirstLoginGuard} from '../_guards/not-first-login.guard';
import {FirstJwtGuard} from '../_guards/first-jwt.guard';
import {LoginGuard} from '../_guards/login.guard';
import {PasswordNotExpiredGuard} from '../_guards/password-not-expired.guard';

const routes: Routes = [
  {path: '', pathMatch: 'full', redirectTo: '/login'},
  {path: 'login', pathMatch: 'full', component: LoginComponent, canActivate: [LoginGuard]},
  {path: 'logout', pathMatch: 'full', component: LoginComponent, canActivate: [LoginGuard], data: {logout: true}},
  {path: 'forgot-password', pathMatch: 'full', component: ForgotPasswordComponent},
  {path: 'first-time-login', pathMatch: 'full', component: FirstTimeLoginComponent, canActivate: [FirstJwtGuard, NotFirstLoginGuard, PasswordNotExpiredGuard]}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule {}
